// The last few teams a user picked in a team dropdown, newest first, kept in this browser so
// dropdowns can list them at the top.
const KEY = 'dugoutscout_recent_teams';
const KEEP = 5;

export function getRecentTeams() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function addRecentTeam(team) {
  if (!team?.name || !team?.teamId) return;
  const rest = getRecentTeams().filter((t) => t.teamId !== team.teamId);
  try {
    localStorage.setItem(KEY, JSON.stringify([{ name: team.name, teamId: team.teamId }, ...rest].slice(0, KEEP)));
  } catch { /* storage unavailable (private mode) -- nothing to remember */ }
}
